import React from 'react';
import { ChartHeaderMenu } from './types';
import { noop } from 'lodash';
import { Divider, Popover } from '@material-ui/core';
import styles from './ChartHeaderMenu.module.scss';
import { ChartHeaderMenuItem } from './ChartHeaderMenuItem';

type ChartHeaderMenuWrapperProps = ChartHeaderMenu;

const ChartHeaderMenuWrapper: React.FC<ChartHeaderMenuWrapperProps> = ({
  anchorEl: parentAnchorElement,
  onClick,
  onClose = noop,
  value,
  items,
  horizontalPosition,
  transformOriginHorizontal,
  transformOriginVertical,
  verticalPosition
}) => {
  const isOpened = Boolean(parentAnchorElement);
  const sectionIds = Object.keys(items);

  return (
    <Popover
      anchorOrigin={{
        vertical: verticalPosition,
        horizontal: horizontalPosition
      }}
      transformOrigin={{
        vertical: transformOriginVertical,
        horizontal: transformOriginHorizontal
      }}
      PaperProps={{
        className: styles.menuContainer
      }}
      elevation={0}
      transitionDuration={0}
      open={isOpened}
      anchorEl={parentAnchorElement}
      onClose={onClose}
      disableEnforceFocus
    >
      {sectionIds.map((section, index) => (
        <div key={section}>
          {items[section].map(item => (
            <ChartHeaderMenuItem
              key={item.value}
              item={item}
              selectedItemValue={value}
              onClick={onClick}
            />
          ))}
          {index < sectionIds.length - 1 && (
            <Divider className={styles.divider} />
          )}
        </div>
      ))}
    </Popover>
  );
};

export default ChartHeaderMenuWrapper;
